var _path, _polygon, _path2, _polygon2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.08,155.05l37.47-37.47a4.95,4.95,0,0,1,7,7l-11.18,11.18,19.07,23.73a2.71,2.71,0,0,1-.2,3.6l-6.65,6.65a2.7,2.7,0,0,1-3.6.2l-23.73-19.07-11.18,11.18a4.95,4.95,0,0,1-7-7Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "105.82 128.12 123.45 141.97 131.78 133.64 117.42 119.29 105.82 128.12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.75,76.62l-8.36-8.37a4.51,4.51,0,0,1,.32-6.66,4.64,4.64,0,0,1,6.18.43l7.44,7.45L93.91,52.05,84,39.39a9,9,0,0,0-5.48-3.3l-36-6.5A7.2,7.2,0,0,0,34.08,38l6.51,36a9,9,0,0,0,3.3,5.48l17.76,14Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "135.76 105.33 124.65 113.79 138.14 127.28 146.46 118.95 135.76 105.33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.92,155.05,40.45,117.58a4.95,4.95,0,0,0-7,7l11.18,11.18L25.56,159.49a2.71,2.71,0,0,0,.2,3.6l6.65,6.65a2.7,2.7,0,0,0,3.6.2l23.73-19.07,11.18,11.18a4.95,4.95,0,0,0,7-7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.41,74l6.51-36a7.2,7.2,0,0,0-8.37-8.36l-36,6.5a9,9,0,0,0-5.48,3.3L53.54,119l8.32,8.33L127.11,62a4.64,4.64,0,0,1,6.18-.43,4.51,4.51,0,0,1,.32,6.66L68.22,133.64,76.55,142l79.56-62.49A9,9,0,0,0,159.41,74Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttack);
export default __webpack_public_path__ + "static/media/attack.5deb698b.svg";
export { ForwardRef as ReactComponent };